import React, { useEffect } from "react";
import { useFormikContext } from "formik";

type FormValues = {
  assetType?: string;
  terrainArea?: string | number | null;
};

/**
 * terrainArea only applies to houses
 */
export const TerrainAreaManager: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  useEffect(() => {
    if (values.assetType === "house") return;

    if (values.terrainArea !== "") {
      setFieldValue("terrainArea", "", false);
    }
  }, [values.assetType, values.terrainArea, setFieldValue]);

  return null;
};
